// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initBootstrapToggle();
    app.initLazyLoad();
    app.initLightbox();
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatepicker();
    app.enquiryDatepickers();
    app.initWowJs();
    app.initStickyEl();
    app.initTooltips();
    app.keepTokenAlive();
    app.announcementBarDismiss();
    app.showScrollIcon();
    app.initSpotlightJs();
    app.responsiveTable();
    app.initTingleModalJs();
    app.initBeforeAfterSlider();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function(e) {
        e.stopPropagation();
    });

});



$.fn.serializeObject = function () {
    "use strict";

    var result = {};
    var extend = function (i, element) {
        var node = result[element.name];

        // If node with same name exists already, need to convert it to an array as it
        // is a multi-value field (i.e., checkboxes)

        if ('undefined' !== typeof node && node !== null) {
            if ($.isArray(node)) {
                node.push(element.value);
            } else {
                result[element.name] = [node, element.value];
            }
        } else {
            result[element.name] = element.value;
        }
    };

    $.each(this.serializeArray(), extend);
    return result;
};


const columnGalleryMenu = document.querySelector('.scroll-container');
let isDown = false;
let startX;
let scrollLeft;
let hasMoved = false;

columnGalleryMenu.addEventListener('mousedown', (e) => {
    isDown = true;
    hasMoved = false;
    columnGalleryMenu.classList.add('active');
    // pageX is the click position, offsetLeft is container position
    startX = e.pageX - columnGalleryMenu.offsetLeft;
    scrollLeft = columnGalleryMenu.scrollLeft;
});

columnGalleryMenu.addEventListener('mouseleave', () => {
    isDown = false;
    columnGalleryMenu.classList.remove('active');
});

columnGalleryMenu.addEventListener('mouseup', (e) => {
    isDown = false;
    columnGalleryMenu.classList.remove('active');

    // If the mouse moved, prevent links from firing
    if (hasMoved) {
        const links = columnGalleryMenu.querySelectorAll('a');
        links.forEach(link => {
            link.onclick = (event) => event.preventDefault();
        });
    } else {
        const links = columnGalleryMenu.querySelectorAll('a');
        links.forEach(link => {
            link.onclick = null;
        });
    }
});

columnGalleryMenu.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    const x = e.pageX - columnGalleryMenu.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed

    // Check if user actually moved enough to be a "drag"
    if (Math.abs(walk) > 5) {
        hasMoved = true;
        e.preventDefault();
        columnGalleryMenu.scrollLeft = scrollLeft - walk;
    }
});

// Prevent images/links from being "dragged" as ghost items
columnGalleryMenu.addEventListener('dragstart', (e) => {
    e.preventDefault();
});

document.addEventListener("DOMContentLoaded", function() {
    const activeItem = document.getElementById('active-gallery-item');
    if (activeItem) {
        // scrollIntoView with 'nearest' or 'center' behavior
        activeItem.scrollIntoView({
            behavior: 'auto', // 'smooth' if you want it to slide on load
            inline: 'center', // Centers the item horizontally
            block: 'nearest'  // Prevents the whole page from jumping vertically
        });
    }
});
